import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ActivityCommands} from './activity/activity.commands';
import {UndoService} from './undo.service';
import {FlowlineCommands} from './flowline/flowline.commands';
import {TextCommands} from './text/text.commands';
import {GeneralCommands} from './general/general.commands';
import {ConnectorCommands} from './connector/connector.commands';
import {ImageCommands} from './image/image.commands';
import {StickerCommands} from './sticky-note/sticker.commands';
import {ResourceCommandService} from './resource/resource.command.service';
import {ResourceCommands} from './resource/resource.commands';

@NgModule({
  imports: [CommonModule],
  providers: [
    ActivityCommands,
    FlowlineCommands,
    ConnectorCommands,
    TextCommands,
    GeneralCommands,
    ImageCommands,
    StickerCommands,
    UndoService,
    ResourceCommands,
    ResourceCommandService
  ]
})
export class CommandsModule {}
